import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import toast from "react-hot-toast";

import logo from "../../assets/images/ai-worker-removebg.png";
import { signin } from "../../services/oprations/authAPI";

const VerifyEmailPage = () => {
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { signinData } = useSelector((state) => state.auth);

  const handleVerify = (e) => {
    e.preventDefault();
    setOtpError("");

    if (!otp) {
      setOtpError("Please enter the OTP");
      return;
    }

    const { email, password } = signinData || {};

    if (!email || !password) {
      toast.error("Invalid session. Please login again.");
      navigate("/login");
      return;
    }

    dispatch(signin(email, password, otp, navigate));
  };

  const handleResend = () => {
    toast.success("OTP resent! (dummy action)");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Centered Logo */}
        <div className="flex justify-center mb-6">
          <img
            src={logo}
            alt="Logo"
            width={180}
            height={40}
            className="object-contain cursor-pointer"
          />
        </div>

        {/* Verify Email Card */}
        <div className="bg-white p-8 rounded-2xl shadow-lg border border-slate-200 text-center">
          <h1 className="text-3xl font-bold text-slate-800 mb-2">Verify your Email</h1>
          <p className="text-slate-500 mb-8">
            Please enter the 6-digit OTP sent to your registered email address.
          </p>

          <form onSubmit={handleVerify} className="space-y-6">
            {/* OTP Input */}
            <div>
              <label
                htmlFor="otp"
                className="text-sm font-medium text-slate-600 block text-left"
              >
                Enter OTP
              </label>
              <input
                type="text"
                id="otp"
                maxLength="6"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                placeholder="123456"
                className={`mt-2 w-full text-center tracking-widest text-lg font-semibold 
                  bg-slate-100 border ${
                    otpError ? "border-red-300 bg-red-50" : "border-slate-200"
                  } rounded-lg focus:ring-2 focus:ring-cyan-400 focus:border-cyan-400 outline-none transition py-3`}
              />
              {otpError && (
                <div className="flex items-center gap-2 text-sm text-red-500 mt-1 animate-pulse">
                  <AlertCircle size={14} />
                  {otpError}
                </div>
              )}
            </div>

            {/* Verify Button */}
            <div>
              <button
                type="submit"
                className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-3 px-4 rounded-lg transition-colors"
              >
                Verify OTP
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;
